// Code for collapsibles
const collapsibles = document.querySelectorAll(".collapsible");
collapsibles.forEach((item) =>
    item.addEventListener("click", function() {
        this.classList.toggle("collapsible--expanded");
    })
);


document.querySelector('#typeNumber').addEventListener('change', (e) => {
    if (isNaN(e.target.value)) {
        e.target.value = ''
    } else {
        e.target.value = formatter.format(e.target.value);
    }
});

//Accordian buttons functions
accordionFunction();

function accordionFunction() {
    const acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            if (panel.style.display === "block") {
                panel.style.display = "none";
            } else {
                panel.style.display = "block";
            }
        });
    }
}

//Contact Us page
$('#select-beast').selectize({
    create: true,
    sortField: {
        field: 'text',
        direction: 'asc'
    },
    dropdownParent: 'body'
});